export class Field {
	private field_name: string = "";
	private is_primary: boolean = false;
	private is_mandatory: boolean = false;
	public editable: boolean = true;
	public value: string = "";

	public constructor(otherField = null) {
		if (otherField != null) {
			Object.keys(otherField).forEach((prop: string) => (this[prop] = otherField[prop]));
		}
	}

	public getValue(): string {
		return this.value;
	}

	public setValue(value: string): void {
		this.value = value;
	}

	public getName(): string {
		return this.field_name;
	}

	public isPrimary(): boolean {
		return this.is_primary;
	}

	public isMandatory(): boolean {
		return this.is_mandatory;
	}
}
